import { useContext } from "react";
import Breadclumbs from "./Breadclumbs";

import { CartProvider } from "./CartContext";
import { FaCheckCircle, FaStar } from "react-icons/fa";
import { Link } from "react-router-dom";

function AddCart() {
  let { cartitem, remove } = useContext(CartProvider);
  console.log(cartitem);

  return (
    <>
      <Breadclumbs />

      {cartitem.length ? (
        cartitem.map((item) => (
          <div className="cart" key={item.id}>
            <div className="image">
              <img src={item.image} alt="" />
            </div>
            <div className="cart-title">
              <Link to={"-burger-test"}>
                <h2>{item.titel}</h2>
              </Link>
            </div>
            <div className="cart-price">
              <div className="price">
                <span>{item.Price}</span>
              </div>
              <div className="rate">
                <FaStar />
                <span>4.5</span>
              </div>
            </div>

            <div className="cart-opiones">
              <div className="opion">
                <FaCheckCircle color="red" size={20} />
                <span>4 Pieces</span>
              </div>
              <div className="opion">
                <FaCheckCircle color="red" size={20} />
                <span>Spicy Sauce</span>
              </div>
            </div>
            <div className="cart-btn">
              <button onClick={() => remove(item.id)}>Delete To Cart</button>
            </div>
          </div>
        ))
      ) : (
        <h2
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "50px",
          }}
        >
          Your Cart is Empty...!!?
        </h2>
      )}
    </>
  );
}

export default AddCart;
